import directorMessage from '$lib/data/directorMessage.js';
import team from '$lib/data/team.js';
import { resolve } from '$lib/utils.js';

export async function load() {
	const about = await resolve({
		directorMessage: directorMessage(),
		team: team()
	});
	let teams = ['sunday_school', 'diploma_team', 'TTC', 'OVBS'];
	let sortedTeam = teams.map((team) => {
		return {
			name: team,
			members: about?.team?.filter((t) => t.field_team === team.toLocaleLowerCase())
		};
	});
	return {
		directorMessage: about?.directorMessage,
		team: sortedTeam
	};
}
